import { render, staticRenderFns } from "./ConferenceCall.vue?vue&type=template&id=2c12f775&scoped=true"
import script from "./ConferenceCall.vue?vue&type=script&lang=js"
export * from "./ConferenceCall.vue?vue&type=script&lang=js"
import style0 from "./ConferenceCall.vue?vue&type=style&index=0&id=2c12f775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c12f775",
  null
  
)

export default component.exports